import React from "react";
import "./styles.css";
import BillerView from "compid/shared/views/BillerView";
import ButtonContainer from "compid/shared/containers/ButtonContainer";
import PageLayoutContainer from "compid/shared/containers/PageLayoutContainer";
import CenterColumnContainer from "compid/shared/containers/PageLayoutContainer/containers/CenterColumnContainer";
import PageView from "compid/shared/containers/PageViewContainer";
import UIButton from "compid/ui/UIButton";

/**
 * @function CanceledEBillPage
 * @returns {React.Component}
 * @exported true
 * @description The confirmation page for the turn off eBill workflow
 * @example
 * <CanceledEBillPage />
 */
export default function CanceledEBillPage(props) {
  return (
    <PageView className="canceled-ebill-page">
      <p className="page-sub-header semi-bold-text">EBILL SERVICE CANCELED</p>

      <PageLayoutContainer>
        <div className="flex-container flex-vertical flex-width all-center">
          <div className="flex-container flex-vertical upper-content-container">
            {/* This needs to match what biller they are canceling an ebill for */}
            <BillerView />
          </div>
          
          <CenterColumnContainer>
            <p className="canceled-message text-center">You'll receive your paper bill starting with your next billing cycle.</p>
            <ButtonContainer>
              <UIButton className="primary-button">Done</UIButton>
            </ButtonContainer>
          </CenterColumnContainer>
        </div>
      </PageLayoutContainer>
    </PageView>
  )
}
